import { Link } from "react-router-dom";
import "./body.css";

 function Body() {
  return (
    <div>
      <div className="landing">
        <div className="row">
          <p className="landingTitle">Télécharger We<span className="mark">Cheers</span></p>
        </div>
        <div className="row">
          <a href="https://apps.apple.com/fr/app/wecheers/id1616746725?l=en-GB"><p className="actionButton">iOS</p></a>
          <a href="https://play.google.com/store/apps/details?id=com.polybris.wecheers&hl=fr_CH"><p className="actionButton">Android</p></a>
        </div>
      </div>
  </div>
  );
}

export default Body;